/**
 * Escapes and wraps a value for PostgREST filter strings (`or`, `and`, etc.).
 * Commas, dots, colons and parentheses in the value otherwise split the logic tree.
 * @see https://postgrest.org/en/stable/references/api/url_grammar.html#reserved-characters
 */
export function quotePostgrestFilterValue(value: string): string {
  const escaped = value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  return `"${escaped}"`;
}

/** Pattern `%term%` for `ilike`, safe inside `or=(...)` when the term has commas etc. */
export function quotedIlikePattern(searchTerm: string): string {
  return quotePostgrestFilterValue(`%${searchTerm}%`);
}
